export const DROP_DIRECTION = {
  before: 0,
  after: 1
}

export const DIRECTION_CLASSNAMES = {
  [DROP_DIRECTION.before]: 'drop-before',
  [DROP_DIRECTION.after]: 'drop-after'
}

const POSITION_SPAN = Math.pow(2,16)

export function calculatePosition(items) {
  const getPreviousAndNextItems = (sourceId, targetId, dropDirection) => {
    const targetIndex = items.findIndex(i => i.id == targetId)
    const isDropBefore = dropDirection == DROP_DIRECTION.before
    const nextItem = items[targetIndex + (isDropBefore ? 0 : 1)]
    const previousItem = items[targetIndex - (isDropBefore ? 1 : 0)]

    //position didn't change
    if (nextItem && nextItem.id == sourceId || previousItem && previousItem.id == sourceId) {
      const sourceIndex = items.findIndex(i => i.id == sourceId)
      return { sourceItem: items[sourceIndex] }
    }
    else {
      return { nextItem, previousItem }
    }
  }

  return ({ sourceId, targetId, dropDirection }) => {
    let { nextItem , previousItem, sourceItem } = getPreviousAndNextItems(sourceId, targetId, dropDirection)

    if(!previousItem && !nextItem){
      return sourceItem.position
    }
    if(!previousItem) {
      previousItem  = {
        position: 0
      }
    }

    if (!nextItem) {
      return parseFloat(previousItem.position + POSITION_SPAN)
    }
    else {
      return parseFloat((previousItem.position + nextItem.position) / 2)
    }
  }
}